import { render, staticRenderFns } from "./RecevershipApplications.vue?vue&type=template&id=3981bfca&scoped=true&"
import script from "./RecevershipApplications.vue?vue&type=script&lang=js&"
export * from "./RecevershipApplications.vue?vue&type=script&lang=js&"
import style0 from "./RecevershipApplications.vue?vue&type=style&index=0&id=3981bfca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3981bfca",
  null
  
)

export default component.exports